import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class RecentlyViewedProducts extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#load();
  }

  /**
   * Fetches the recently viewed products via the search endpoint (search by id)
   * and injects the server-rendered cards into this section.
   */
  async #load() {
    const excludeProductId = this.dataset.excludeProductId;
    const productIds = RecentlyViewed.getProducts().filter((id) => id !== excludeProductId);
    if (productIds.length === 0) {
      return;
    }

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    const html = await sectionRenderer.getSectionHTML(this.dataset.sectionId, false, url);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = doc.querySelector('.recently-viewed-products__content');

    // No products to show (e.g. all viewed products were deleted) — stay hidden.
    if (!content || content.querySelectorAll('.recently-viewed-products__card').length === 0) {
      return;
    }

    const target = this.querySelector('.recently-viewed-products__content');
    if (target) {
      target.innerHTML = content.innerHTML;
      this.hidden = false;
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
